var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_42-Certificate",
    "data-name": "42-Certificate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.71 8.29-6-6a1 1 0 0 0 -.71-.29h-12a3 3 0 0 0 -3 3v2a1 1 0 0 0 2 0v-2a1 1 0 0 1 1-1h11v3a3 3 0 0 0 3 3h3v17a1 1 0 0 1 -1 1h-12a1 1 0 0 0 0 2h12a3 3 0 0 0 3-3v-18a1 1 0 0 0 -.29-.71zm-5.71-1.29v-1.59l2.59 2.59h-1.59a1 1 0 0 1 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 16a6 6 0 1 0 -10 4.46v8.54a1 1 0 0 0 .62.92 1 1 0 0 0 1.09-.21l2.29-2.3 2.29 2.3a1 1 0 0 0 .71.29.84.84 0 0 0 .38-.08 1 1 0 0 0 .62-.92v-8.54a6 6 0 0 0 2-4.46zm-4 10.59-1.29-1.3a1 1 0 0 0 -1.42 0l-1.29 1.3v-4.94a5.89 5.89 0 0 0 4 0zm-2-6.59a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 8h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 13h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 18h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 23h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.18d26b8c21905d7a1beb13865d47f8bf.svg";
export { ForwardRef as ReactComponent };